"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var UnknownPhone = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_UnknownPhone_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 10,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM7 6.455c0-.513.433-.955 1-.955s1 .442 1 .955a.948.948 0 0 1-.514.834c-.396.21-.986.658-.986 1.37v.091a.5.5 0 0 0 1 0v-.09c0-.056.022-.128.102-.221.082-.096.207-.19.354-.267A1.948 1.948 0 0 0 10 6.455C10 5.36 9.09 4.5 8 4.5c-1.09 0-2 .86-2 1.955a.5.5 0 0 0 1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.092 15.782C4.52 16 5.08 16 6.2 16h3.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C13 14.48 13 13.92 13 12.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C11.48 0 10.92 0 9.8 0H6.2C5.08 0 4.52 0 4.092.218a2 2 0 0 0-.874.874C3 1.52 3 2.08 3 3.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874ZM4 3.2v9.6c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C5.25 15 5.623 15 6.2 15h3.6c.577 0 .949 0 1.232-.024.272-.022.373-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C12 13.75 12 13.377 12 12.8V3.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C10.75 1 10.377 1 9.8 1H6.2c-.577 0-.949 0-1.232.024-.272.022-.373.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C4 2.25 4 2.623 4 3.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_UnknownPhone_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = UnknownPhone;
exports["default"] = _default;